import {UIView} from "uicore-ts"
import {RHContractingAuthorityRules} from "../ContractingAuthorityRules"
import {RHRadioButton} from "../Custom components/RH/RHRadioButton"
import {RHForms, RHSpacing} from "../Custom components/RH/Utils_slop/RHDesignTokens"


export class ContractingAuthorityChoicesView extends UIView {

    readonly options = RHContractingAuthorityRules.types.map(authorityType => ({
        authorityType,
        button: new RHRadioButton().configuredWithObject({
            titleLabel: { text: RHContractingAuthorityRules.definitions[authorityType].title }
        })
    }))


    override layoutSubviews() {
        super.layoutSubviews()
        const bounds = this.contentBoundsWithInset(0)
        const buttons = this.options.map(option => option.button).filter(button => button.superview === this)
        if (buttons.length === 0) {
            // Can be momentarily true for a freshly constructed instance: the parent
            // container measures this view's intrinsic height (to size itself) before
            // NewProcurementViewController.viewWillAppear has run the selection logic
            // that mounts the allowed buttons.
            return
        }
        const widths = buttons.map(button => button.intrinsicContentWidth())
        const rowWidth = widths.reduce((sum, width) => sum + width, 0) +
            RHSpacing.medium * Math.max(0, buttons.length - 1)
        const rowHeight = Math.max(RHForms.radioControlSize,
            ...buttons.map(button => button.titleLabel.intrinsicContentHeight()))
        bounds
            .rectangleWithHeight(rowHeight)
            .IF(rowWidth <= bounds.width)
            .framesByDistributingViewsAsRow(buttons, RHSpacing.medium, widths)
            .ELSE()
            .framesByDistributingViewsAsColumn(buttons, RHSpacing.small, rowHeight)
            .ENDIF()
    }
}
